import React from "react";
import { themes } from "services/constants";
import * as Mui from "@mui/material";
import { CustomButton } from "components/CustomComponents";
import { showToast } from "services/utils/Status";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Tooltip,
  Paper,
} from "@mui/material";
import { cardBorder } from "services/constants";
import { customAPI } from "services/utils/CustomAPI";
import { useSelector } from "react-redux";
import { tooltipStyleProps } from "services/constants/Styles";
import { useForm } from "react-hook-form";
import { Loader } from "components/Loader";
import { useShiftRota } from "../ShiftRotaContext";
import { stickyHeader } from "services/constants";

export const ShiftRotaPreview = ({
  handleBack,
  reCallApi,
  loader,
  isEdit,
  isCreate,
  isClone,
  onClose,
  isPreview,
  setHandleLoader,
  setOpenSidePeak,
}) => {
  const {
    formData,
    WeekDaysData,
    setGetShiftRotaData,
    representationWeekdays,
    representationShifts,
    allGroupDetails,
    shiftCycleDetails,
    shiftRotationDetails,
    representationNonRandon,
    setNumberOfSft,
  } = useShiftRota();
  const weekDays = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
  const { domain } = useSelector((state) => state.tokenReducer);
  const { watch, setValue } = useForm();

  const createShiftAssignWithCloseOption = async () => {
    if (!isEdit && !isClone) {
      if (
        formData?.schedule?.rotation_based_on === "Weekdays" &&
        formData?.config?.no_of_shifts !== "1"
      ) {
        setValue("button_loader", true);
        const response = await customAPI(
          `${domain}administration/shiftroster/shiftrota/shift-assignments/`,
          "POST",
          {
            name: formData?.config?.shift_assignment_name.trim(),
            rotation_based_on: formData?.schedule?.rotation_based_on,
            shift_groups:
              formData?.config?.shiftGroup?.map((item) => item.id) || [],
            shifts: formData?.config?.shift?.map((item) => item.id) || [],
            rotation_frequency:
              formData?.schedule?.rotation_frequency === "Week"
                ? "Weekly"
                : "Monthly",
            rotation_day: formData?.schedule?.rotation_day_week,
            no_of_repetition: parseInt(
              formData?.schedule?.duration_for_one_cycle
            ),
            start_date: formData?.config?.effective_from,
            auto_shift_assign: formData?.schedule?.auto_sft_assign === "Yes",
            first_rotation_date: formData?.schedule?.first_rotation_date
              .split("/")
              .reverse()
              .join("-"),
            cycles: WeekDaysData,
            number_of_shifts: formData?.config?.no_of_shifts,
          }
        );
        if (response.ok) {
          showToast("success", response?.responseDetails?.message);
          setHandleLoader(true);
          reCallApi(true);
          setValue("button_loader", false);
          onClose();
        }
      } else if (
        formData?.schedule?.rotation_based_on === "Shift" &&
        formData?.config?.no_of_shifts !== "1"
      ) {
        setValue("button_loader", true);
        const response = await customAPI(
          `${domain}administration/shiftroster/shiftrota/shift-assignment-based-shift/`,
          "POST",
          {
            name: formData?.config?.shift_assignment_name.trim(),
            rotation_based_on: formData?.schedule?.rotation_based_on,
            shift_groups:
              formData?.config?.shiftGroup?.map((item) => item.id) || [],
            shifts: formData?.config?.shift?.map((item) => item.id) || [],
            rotation_frequency:
              formData?.schedule?.rotation_frequency === "Week"
                ? "Weekly"
                : "Monthly",
            rotation_day:
              formData?.schedule?.rotation_frequency === "Month"
                ? parseInt(formData?.schedule?.rotation_month_day)
                : formData?.schedule?.rotation_day_week,
            no_of_repetition: parseInt(
              formData?.schedule?.duration_for_one_cycle
            ),
            start_date: formData?.config?.effective_from,
            auto_shift_assign: formData?.schedule?.auto_sft_assign === "Yes",
            first_rotation_date: formData?.schedule?.first_rotation_date
              .split("/")
              .reverse()
              .join("-"),
            cycles: shiftCycleDetails,
            number_of_shifts: formData?.config?.no_of_shifts,
          }
        );

        if (response.ok) {
          showToast("success", response?.responseDetails?.message);
          reCallApi(true);
          setHandleLoader(true);
          setValue("button_loader", false);
          onClose();
        }
      } else {
        setValue("button_loader", true);
        const response = await customAPI(
          `${domain}administration/shiftroster/shiftrota/shift-assignment-based-shift/`,
          "POST",
          {
            name: formData?.config?.shift_assignment_name.trim(),
            shift_groups:
              formData?.config?.shiftGroup?.map((item) => item.id) || [],
            shifts: formData?.config?.shift?.map((item) => item.id) || [],
            start_date: formData?.config?.effective_from,
            number_of_shifts: formData?.config?.no_of_shifts,
            shift_type: formData?.config?.is_random,
            cycles: [],
          }
        );

        if (response.ok) {
          showToast("success", response?.responseDetails?.message);
          setHandleLoader(true);
          reCallApi(true);
          setValue("button_loader", false);
          setNumberOfSft(false);
          onClose();
        }
      }
      setValue("button_loader", false);
    } else {
      if (
        formData?.schedule?.rotation_based_on === "Weekdays" &&
        formData?.config?.no_of_shifts !== "1"
      ) {
        setValue("button_loader", true);
        const response = await customAPI(
          `${domain}administration/shiftroster/shiftrota/shift-assignments/${formData?.config?.sft_assignment_id}/`,
          "PUT",
          {
            action: isEdit ? "edit" : "clone",
            name: formData?.config?.shift_assignment_name.trim(),
            rotation_based_on: formData?.schedule?.rotation_based_on,
            shift_groups:
              formData?.config?.shiftGroup?.map((item) => item.id) || [],
            shifts: formData?.config?.shift?.map((item) => item.id) || [],
            rotation_frequency:
              formData?.schedule?.rotation_frequency === "Week"
                ? "Weekly"
                : "Monthly",
            rotation_day: formData?.schedule?.rotation_day_week,
            no_of_repetition: parseInt(
              formData?.schedule?.duration_for_one_cycle
            ),
            start_date: formData?.config?.effective_from,
            auto_shift_assign: formData?.schedule?.auto_sft_assign === "Yes",
            first_rotation_date: formData?.schedule?.first_rotation_date
              .split("/")
              .reverse()
              .join("-"),
            cycles: WeekDaysData,
            number_of_shifts: formData?.config?.no_of_shifts,
          }
        );
        if (response.ok) {
          showToast("success", response?.responseDetails?.message);
          setGetShiftRotaData(true);
          if (!isEdit) {
            setOpenSidePeak(false);
            setHandleLoader(true);
          } else {
            setHandleLoader(false);
          }
          reCallApi(true);
          setValue("button_loader", false);
          onClose();
        }
      } else if (
        formData?.schedule?.rotation_based_on === "Shift" &&
        formData?.config?.no_of_shifts !== "1"
      ) {
        setValue("button_loader", true);
        const response = await customAPI(
          `${domain}administration/shiftroster/shiftrota/shift-assignment-based-shift/${formData?.config?.sft_assignment_id}/`,
          "PUT",
          {
            action: isEdit ? "edit" : "clone",
            name: formData?.config?.shift_assignment_name.trim(),
            rotation_based_on: formData?.schedule?.rotation_based_on,
            shift_groups:
              formData?.config?.shiftGroup?.map((item) => item.id) || [],
            shifts: formData?.config?.shift?.map((item) => item.id) || [],
            rotation_frequency:
              formData?.schedule?.rotation_frequency === "Week"
                ? "Weekly"
                : "Monthly",
            rotation_day:
              formData?.schedule?.rotation_frequency === "Month"
                ? parseInt(formData?.schedule?.rotation_month_day)
                : formData?.schedule?.rotation_day_week,
            no_of_repetition: parseInt(
              formData?.schedule?.duration_for_one_cycle
            ),
            start_date: formData?.config?.effective_from,
            auto_shift_assign: formData?.schedule?.auto_sft_assign === "Yes",
            first_rotation_date: formData?.schedule?.first_rotation_date
              .split("/")
              .reverse()
              .join("-"),
            cycles: shiftCycleDetails,
            number_of_shifts: formData?.config?.no_of_shifts,
          }
        );

        if (response.ok) {
          showToast("success", response?.responseDetails?.message);
          setGetShiftRotaData(true);
          if (!isEdit) {
            setOpenSidePeak(false);
            setHandleLoader(true);
          } else {
            setHandleLoader(false);
          }
          reCallApi(true);
          setValue("button_loader", false);
          setNumberOfSft(false);
          onClose();
        }
      } else {
        setValue("button_loader", true);
        const response = await customAPI(
          `${domain}administration/shiftroster/shiftrota/shift-assignment-based-shift/${formData?.config?.sft_assignment_id}/`,
          "PUT",
          {
            action: isEdit ? "edit" : "clone",
            name: formData?.config?.shift_assignment_name.trim(),
            shift_groups:
              formData?.config?.shiftGroup?.map((item) => item.id) || [],
            shifts: formData?.config?.shift?.map((item) => item.id) || [],
            start_date: formData?.config?.effective_from,
            number_of_shifts: formData?.config?.no_of_shifts,
            shift_type: formData?.config?.is_random,
            cycles: [],
          }
        );

        if (response.ok) {
          showToast("success", response?.responseDetails?.message);
          setGetShiftRotaData(true);
          if (!isEdit) {
            setOpenSidePeak(false);
            setHandleLoader(true);
          } else {
            setHandleLoader(false);
          }
          reCallApi(true);
          setValue("button_loader", false);
          onClose();
        }
      }
      setValue("button_loader", false);
    }
  };

  return loader ? (
    <Loader />
  ) : (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ flexGrow: 1, overflow: "auto", p: 2 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2.5,
          }}
        >
          <Box mb={8}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{ color: themes?.headLine }}
              textAlign="center"
              mb={4}
            >
              {formData?.config?.shift_assignment_name}
            </Typography>
            <Grid container spacing={3} mb={6}>
              <Grid item xs={12} lg={6}>
                <Box display="flex" flexDirection="column" gap={3}>
                  <Card sx={{ ...cardBorder, height: "100%" }}>
                    <CardContent sx={{ p: 3, height: "100%" }}>
                      <Box mb={1} display="flex" alignItems="center">
                        <Typography
                          variant="body1"
                          fontWeight={500}
                          color="#09bd71"
                        >
                          Shift:
                        </Typography>
                        <Typography variant="body1" fontWeight="bold" ml={1}>
                          {formData?.config?.shift?.length}
                        </Typography>
                      </Box>

                      <Box mb={2}>
                        {formData?.config?.shift.map((shift, index) => (
                          <Typography key={index} fontWeight={500}>
                            {shift?.name}
                          </Typography>
                        ))}
                      </Box>
                    </CardContent>
                  </Card>

                  <Card sx={{ ...cardBorder, height: "100%" }}>
                    <CardContent sx={{ p: 3, height: "100%" }}>
                      <Box mb={2} display="flex" alignItems="center">
                        <Typography
                          variant="body1"
                          fontWeight={500}
                          color="#09bd71"
                        >
                          Shift Groups:
                        </Typography>
                        <Typography variant="body1" fontWeight="bold" ml={1}>
                          {formData?.config?.shiftGroup?.length}
                        </Typography>
                      </Box>

                      <Box mb={2}>
                        {formData?.config?.shiftGroup.map((group, index) => (
                          <Typography key={index} fontWeight={500}>
                            {group?.name}
                          </Typography>
                        ))}
                      </Box>
                    </CardContent>
                  </Card>
                </Box>
              </Grid>
              {(formData?.schedule?.rotation_based_on === "Weekdays" ||
                formData?.schedule?.rotation_based_on === "Shift") &&
              formData?.config?.no_of_shifts !== "1" ? (
                <Grid item xs={12} lg={6}>
                  <Card sx={{ ...cardBorder, width: "100%" }}>
                    <CardContent sx={{ p: 3, height: "100%" }}>
                      <Typography
                        variant="body1"
                        fontWeight={500}
                        color="#09bd71"
                        sx={{ mb: 1 }}
                      >
                        Rotation
                      </Typography>
                      {[
                        {
                          label: "Based on",
                          value:
                            formData?.schedule?.rotation_based_on === "Weekdays"
                              ? representationWeekdays.rotation_based_on
                              : shiftRotationDetails?.rotation_based_on,
                        },
                        {
                          label: "Frequency",
                          value:
                            formData?.schedule?.rotation_based_on === "Weekdays"
                              ? representationWeekdays.rotation_frequency
                              : shiftRotationDetails?.rotation_frequency,
                        },
                        {
                          label: "Rotation Day",
                          value:
                            formData?.schedule?.rotation_based_on === "Weekdays"
                              ? representationWeekdays.rotation_day
                              : shiftRotationDetails?.rotation_day,
                        },
                        {
                          label: "No of Repetition",
                          value:
                            formData?.schedule?.rotation_based_on === "Weekdays"
                              ? representationWeekdays.no_of_repetition
                              : shiftRotationDetails?.no_of_repetition,
                        },
                        {
                          label: "Effective From",
                          value:
                            formData?.schedule?.rotation_based_on === "Weekdays"
                              ? representationWeekdays.start_date
                              : shiftRotationDetails?.start_date,
                        },
                        {
                          label: "First Rotation on",
                          value:
                            formData?.schedule?.rotation_based_on === "Weekdays"
                              ? representationWeekdays.first_rotation_date
                              : shiftRotationDetails?.first_rotation_date,
                        },
                      ].map((item, i) => (
                        <Grid container key={i} spacing={1} sx={{ mb: 2 }}>
                          <Grid item xs={6}>
                            <Typography variant="body2" color="text.secondary">
                              {item.label}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography fontWeight={500}>
                              {item.value}
                            </Typography>
                          </Grid>
                        </Grid>
                      ))}
                    </CardContent>
                  </Card>
                </Grid>
              ) : (
                <Grid item xs={12} lg={6}>
                  <Card sx={cardBorder}>
                    <CardContent sx={{ p: 3 }}>
                      <Typography
                        variant="body1"
                        fontWeight={500}
                        color="#09bd71"
                        sx={{ mb: 1 }}
                      >
                        Rotation
                      </Typography>
                      {[
                        {
                          label: "Effective From",
                          value: representationNonRandon?.start_date,
                        },
                      ].map((item, i) => (
                        <Grid container key={i} spacing={1} sx={{ mb: 2 }}>
                          <Grid item xs={6}>
                            <Typography variant="body2" color="text.secondary">
                              {item.label}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography fontWeight={500}>
                              {item.value}
                            </Typography>
                          </Grid>
                        </Grid>
                      ))}
                    </CardContent>
                  </Card>
                </Grid>
              )}
            </Grid>
            {formData?.schedule?.rotation_based_on === "Weekdays" &&
            formData?.config?.no_of_shifts !== "1" ? (
              <Box mb={4}>
                {representationWeekdays?.shift_groups?.map((shift) => (
                  <>
                    <Mui.Grid container sx={{ ml: 1, mt: 2 }}>
                      <Typography
                        variant="body1"
                        fontWeight={500}
                        color="#09bd71"
                      >
                        {shift?.shift_group_name}
                      </Typography>
                    </Mui.Grid>
                    <TableContainer
                      component={Paper}
                      sx={{
                        marginTop: 2,
                        marginLeft: "auto",
                        marginRight: "auto",
                        overflowX: "auto",
                        width: "100%",
                        maxWidth: 1300,
                        maxHeight: 450,
                      }}
                    >
                      <Table
                        sx={{
                          width: "100%",
                          tableLayout: "auto",
                          border: "1px solid #0000002b",
                        }}
                      >
                        <TableHead sx={stickyHeader}>
                          <TableRow>
                            <TableCell
                              sx={{
                                minWidth: 80,
                                fontWeight: 600,
                                textAlign: "center",
                                backgroundColor: themes.primary,
                                borderRight: "1px solid #0000002b",
                                borderBottom: "1px solid #0000002b",
                                position: "sticky",
                                left: -1,
                                zIndex: 1,
                              }}
                            >
                              Cycle
                            </TableCell>
                            {weekDays.map((data, i) => (
                              <TableCell
                                key={i}
                                sx={{
                                  minWidth: 250,
                                  fontWeight: 600,
                                  textAlign: "center",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  backgroundColor: themes.primary,
                                  borderRight: "1px solid #0000002b",
                                  borderBottom: "1px solid #0000002b",
                                }}
                              >
                                {data}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {shift?.cycles?.map((item, index) => (
                            <TableRow key={index}>
                              {/* Cycle column */}
                              <TableCell
                                sx={{
                                  textAlign: "center",
                                  backgroundColor: themes.primary,
                                  borderRight: "1px solid #0000002b",
                                  borderBottom: "1px solid #0000002b",
                                  position: "sticky",
                                  left: -1,
                                  zIndex: 1,
                                }}
                              >
                                Cycle {item?.cycle_number}
                              </TableCell>

                              {/* Assignments */}
                              {item?.assignments?.map((head, idx) => (
                                <TableCell
                                  key={idx}
                                  sx={{
                                    minWidth: 250,
                                    backgroundColor: head.shift_color,
                                    textAlign: "center",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    borderRight: "1px solid #0000002b",
                                    borderBottom: "1px solid #0000002b",
                                  }}
                                >
                                  <Typography
                                    fontSize={14}
                                    fontWeight={500}
                                    mb={0.5}
                                  >
                                    {head?.shift_name}
                                  </Typography>
                                  <Typography fontSize={12}>
                                    {`${head?.start_time?.slice(
                                      0,
                                      5
                                    )} - ${head?.end_time?.slice(0, 5)}`}
                                  </Typography>
                                </TableCell>
                              ))}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                ))}
              </Box>
            ) : formData?.schedule?.rotation_based_on === "Shift" &&
              formData?.config?.no_of_shifts !== "1" ? (
              <Box mb={4}>
                {representationShifts?.length !== 0 ? (
                  <TableContainer
                    component={Paper}
                    sx={{
                      marginTop: 2,
                      marginLeft: "auto",
                      marginRight: "auto",
                      overflowX: "auto",
                      width: "100%",
                      maxWidth: 1300,
                      maxHeight: 450,
                    }}
                  >
                    <Table
                      sx={{
                        width: "100%",
                        tableLayout: "auto",
                        border: "1px solid #0000002b",
                      }}
                    >
                      <TableHead sx={stickyHeader}>
                        <TableRow>
                          <TableCell
                            sx={{
                              minWidth: 80,
                              fontWeight: 600,
                              textAlign: "center",
                              backgroundColor: themes.primary,
                              borderRight: "1px solid #0000002b",
                              borderBottom: "1px solid #0000002b",
                              position: "sticky",
                              left: -1,
                              zIndex: 1,
                            }}
                          >
                            Cycle
                          </TableCell>
                          <TableCell
                            sx={{
                              minWidth: 250,
                              fontWeight: 600,
                              textAlign: "center",
                              backgroundColor: themes.primary,
                              borderRight: "1px solid #0000002b",
                              borderBottom: "1px solid #0000002b",
                            }}
                          >
                            Date
                          </TableCell>
                          {allGroupDetails.map((head) => (
                            <Mui.TableCell
                              sx={{
                                fontWeight: 600,
                                fontSize: 14,
                                backgroundColor: "#f5f5fd",
                                borderRight: "1px solid #0000002b",
                                borderBottom: "1px solid #0000002b",
                                width: 100,
                                textAlign: "center",
                              }}
                            >
                              {head.name}
                            </Mui.TableCell>
                          ))}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {representationShifts?.map((item, index) => (
                          <TableRow key={index}>
                            <TableCell
                              sx={{
                                textAlign: "center",
                                backgroundColor: themes.primary,
                                borderRight: "1px solid #0000002b",
                                borderBottom: "1px solid #0000002b",
                                position: "sticky",
                                left: -1,
                                zIndex: 1,
                              }}
                            >
                              Cycle {index + 1}
                            </TableCell>
                            <Mui.TableCell
                              sx={{
                                minWidth: 250,
                                textAlign: "center",
                                borderRight: "1px solid #0000002b",
                                borderBottom: "1px solid #0000002b",
                              }}
                            >
                              {item?.date}
                            </Mui.TableCell>
                            {allGroupDetails.map((group) => {
                              const assignment = item.assignment.find(
                                (a) => a.shift_group_id === group?.id
                              );

                              return (
                                <TableCell
                                  key={group.shift_group_id}
                                  sx={{
                                    minWidth: 200,
                                    backgroundColor:
                                      assignment?.color_code || "#f5f5f5",
                                    textAlign: "center",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    borderRight: "1px solid #0000002b",
                                    borderBottom: "1px solid #0000002b",
                                  }}
                                >
                                  {assignment ? (
                                    <>
                                      <Typography
                                        fontSize={14}
                                        fontWeight={500}
                                        mb={0.5}
                                      >
                                        {assignment.shift_name}
                                      </Typography>
                                      <Typography fontSize={12}>
                                        {`${assignment.start_time?.slice(
                                          0,
                                          5
                                        )} - ${assignment.end_time?.slice(
                                          0,
                                          5
                                        )}`}
                                      </Typography>
                                    </>
                                  ) : (
                                    <Typography
                                      fontSize={12}
                                      color="text.secondary"
                                    >
                                      —
                                    </Typography>
                                  )}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : null}
              </Box>
            ) : (
              <>
                {representationNonRandon?.length !== 0 ? (
                  <Box>
                    <TableContainer
                      component={Paper}
                      sx={{
                        marginTop: 2,
                        marginLeft: "auto",
                        marginRight: "auto",
                        overflowX: "auto",
                        width: "100%",
                        maxWidth: 1300,
                      }}
                    >
                      <Table
                        sx={{
                          width: "100%",
                          tableLayout: "auto",
                          border: "1px solid #0000002b",
                        }}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell
                              sx={{
                                minWidth: 60,
                                fontWeight: 600,
                                textAlign: "center",
                                backgroundColor: themes.primary,
                                borderRight: "1px solid #0000002b",
                                borderBottom: "1px solid #0000002b",
                                position: "sticky",
                                left: -1,
                                zIndex: 1,
                              }}
                            >
                              Cycle
                            </TableCell>
                            <TableCell
                              sx={{
                                minWidth: 120,
                                fontWeight: 600,
                                textAlign: "center",
                                backgroundColor: themes.primary,
                                borderRight: "1px solid #0000002b",
                                borderBottom: "1px solid #0000002b",
                              }}
                            >
                              Date
                            </TableCell>
                            {allGroupDetails.map((head, idx) => (
                              <TableCell
                                key={idx}
                                sx={{
                                  minWidth: 200,
                                  fontWeight: 600,
                                  textAlign: "center",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  backgroundColor: themes.primary,
                                  borderRight: "1px solid #0000002b",
                                  borderBottom: "1px solid #0000002b",
                                }}
                              >
                                {head.name}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          <TableRow>
                            <TableCell
                              sx={{
                                textAlign: "center",
                                backgroundColor: themes.primary,
                                borderRight: "1px solid #0000002b",
                                borderBottom: "1px solid #0000002b",
                                position: "sticky",
                                left: -1,
                                zIndex: 1,
                              }}
                            >
                              Cycle
                            </TableCell>
                            <TableCell
                              sx={{
                                textAlign: "center",
                                borderRight: "1px solid #0000002b",
                                borderBottom: "1px solid #0000002b",
                              }}
                            >
                              {representationNonRandon?.start_date}
                            </TableCell>
                            {representationNonRandon?.shift_groups.map(
                              (group, gIdx) => (
                                <React.Fragment key={gIdx}>
                                  {group?.cycles.map((cyc, cIdx) => (
                                    <TableCell
                                      key={cIdx}
                                      sx={{
                                        minWidth: 200,
                                        backgroundColor: cyc.color_code,
                                        textAlign: "center",
                                        whiteSpace: "normal",
                                        wordBreak: "break-word",
                                        borderRight: "1px solid #0000002b",
                                        borderBottom: "1px solid #0000002b",
                                      }}
                                    >
                                      <Typography
                                        fontSize={14}
                                        fontWeight={500}
                                        mb={0.5}
                                      >
                                        {cyc.shift_name}
                                      </Typography>
                                      <Typography fontSize={12}>
                                        {`${cyc?.start_time?.slice(
                                          0,
                                          5
                                        )} - ${cyc?.end_time?.slice(0, 5)}`}
                                      </Typography>
                                    </TableCell>
                                  ))}
                                </React.Fragment>
                              )
                            )}
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                ) : null}
              </>
            )}

            <Box
              display="grid"
              gridTemplateColumns="repeat(3, 1fr)"
              gap={3}
              sx={{ ml: 5, mt: 2 }}
            >
              {formData?.config?.shift.map((shift, index) => (
                <Box key={index} display="flex" alignItems="center" gap={1}>
                  <Box
                    sx={{
                      width: 20,
                      height: 20,
                      backgroundColor: shift?.color_code,
                      border: "1px solid #00000040",
                      borderRadius: "2px",
                    }}
                  />
                  <Tooltip
                    title={shift?.name || ""}
                    arrow
                    slotProps={tooltipStyleProps}
                  >
                    <Typography fontWeight={500} noWrap sx={{ maxWidth: 120 }}>
                      {shift?.name}
                    </Typography>
                  </Tooltip>
                </Box>
              ))}
            </Box>
          </Box>

          {!isPreview && (
            <Box
              sx={{
                ml: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <CustomButton
                  actionName="Prev"
                  typeName="button"
                  actionFuntion={() => {
                    handleBack(formData?.config?.shift?.length === 1 ? 0 : 1);
                  }}
                />
              </Box>
              <Box>
                <CustomButton
                  actionFuntion={() => createShiftAssignWithCloseOption()}
                  actionName={isEdit ? "Update" : isCreate ? "Create" : "Clone"}
                  typeName="button"
                  disableAction={watch("button_loader")}
                />
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
